<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-26 18:15:08
 * @LastEditTime: 2019-09-20 13:33:41
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div id="page_Container" class="evabody">
        <div class="page">
            <!--导航栏-->
            <!-- <navigation title="评价"  :left-arrow="true"/> -->
            <div id="main-container" class="main-container">
                <div class="refresh-style">
                    <div class="evatitle">商品评价（{{totalnum}}）</div>
                    <div class='cartPicFixed' @click.prevent="gocartpage()">
                        <img src="../assets/img/goods/cartPic.png" alt="">
                    </div>
                    <!-- <van-pull-refresh :class="{flexClass:!listShow}" v-model="isLoading" @refresh="onRefresh"> -->
                        <van-list v-model="ploading" :finished="finished"  @load="onLoad" :offset="1">
                            <div  v-for="(eva, index) in evaslist" :key="index.id">
                                <!-- <evaluationCommon :productComment="eva" :evabuttonFlag="false" :imgShow="true" :changeFlag='true' @imgshowFun="imgdataFun" :showRate="true" :isLimit="false"></evaluationCommon> -->
                                <evaluationCommon :productComment="eva" :evabuttonFlag="false" :imgShow="true" :changeFlag='true' :showRate="true" :isLimit="false"></evaluationCommon>
                            </div>
                        </van-list>
                    <!-- </van-pull-refresh> -->
                    <van-popup v-model="show" class="popupStyle" close-on-click-overlay>
                        <div class="dialogImg">
                            <img :src="img" alt="">
                            <img class="close-btn" @click="closeFun" src="../assets/img/common/close-btn.png" alt="">
                        </div>
                    </van-popup>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import evaluationCommon from '@/components/common/evaluationCommon';
import { toastLoading, clearToastLoading } from '@/utils/base/utils';

export default {
    components: {
        evaluationCommon
    },
    data () {
        return {
            evaslist: [],
            listShow: false,
            list: [],
            totalnum: 0,
            loading: false,
            isLoading: false,
            ploading: false,
            finished: true,
            pageNum: 1,
            pageSize: 3,
            img: '',
            show: false
        };
    },
    esvReady: function() {
        document.title = '商品评价';
        const ths = this;
        ths.queryData();
    },
    methods: {
        gocartpage() {
            const ths = this;
            ths.esvOpenPage({ name: 'OPShoppingcart', params: {} });
        },
        imgdataFun(img, show) {
            this.img = img;
            this.show = show;
        },
        queryData() {
            const ths = this;
            // ths.loading = true;
            let goodsId;
            this.ESVStorage.getSavedValue('goodsId', (data) => {
                goodsId = data;
            });
            ths.$doRequest(
                {
                    url: '/comment/queryProductCommentList',
                    params: {
                        pageNum: ths.pageNum,
                        pageSize: ths.pageSize,
                        // productId: 1
                        // productId: ths.$route.params.goodsId
                        productId: goodsId

                    },
                    before: function() {
                        ths.loading = toastLoading();
                    },
                    complete: function() {
                        // ths.loading = false;
                        ths.ploading = false;
                        clearToastLoading(ths.loading);
                    }
                },
                function (data) {
                    ths.totalnum = data.result.total;
                    // ths.evaslist = data.result.list;
                    const total = parseInt(data.result.total);
                    ths.evaslist =
                        ths.pageNum === 1
                            ? data.result.list
                            : [...ths.evaslist, ...data.result.list];

                    if (ths.evaslist.length < total) {
                        ths.finished = false;
                    } else {
                        ths.finished = true;
                    }
                }
            );
        },
        // 下拉刷新
        onLoad() {
            this.pageNum++;
            this.queryData();
        },
        onRefresh() {
            setTimeout(() => {
                this.pageNum = 1;
                this.queryData();
                this.loadingTextShow = false;
                this.isLoading = false;
            }, 500);
        },
        closeFun() {
            this.show = false;
        }
    }
};
</script>
<style lang="scss" scoped>
.dialogImg {
    position: relative;
    background: #999;
    width: 100%;
    height: 372px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
        max-width: 100%;
        max-height: 100%;
        width: auto;
        height: auto;
    }
    .close-btn {
        position: absolute;
        bottom: -43px;
        width: 32px;
        height: 32px;
    }

}
.evabody{
    background-color: #f3f3f3;
    .flexClass{
        height: 100%;
    }
}
.evatitle{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    padding: 12px;
    color: #414141;
    font-size: 16px;
    background-color: #fff;
    z-index: 100;
}
.van-list{
    height: 100%;
}
.flexClass{
    display: block;
}
.cartPicFixed{
    position:fixed;
    top:15px;
    right:15px;
    z-index: 100;
    img{
        width:32px;
    }
}
</style>
